import '../styles/LegalPage.scss'

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <h1>Politique de confidentialité</h1>

      <h3>Données personnelles</h3>
      <p>
        Ton portfolio ne collecte aucune donnée personnelle, et il n’y a ni formulaire de contact, ni système d’analytics, ni cookies.
      </p>


      <h3>Pas de traitement de données</h3>
      <p>
        En conséquence, il n’y a aucun traitement de données personnelles effectué (collecte, stockage ou partage), donc aucune finalité, durée de conservation ou destinataire à mentionner.
      </p>


      <h3>Conformité RGPD</h3>
      <p>
        Ce site ne crée pas de fichiers de données personnelles, et n’exécute aucune analyse ou suivi d’utilisateurs, ce qui fait qu’il n’y a aucune donnée soumise au RGPD à traiter.
      </p>


      <h3>Contact</h3>
      <p>
        Pour toute question relative à la confidentialité :
        Email : charlenevilliette70@gmail.com
      </p>
    </div>
  );
}

export default PrivacyPolicy;
